import { render, staticRenderFns } from "./OcorrenciaEdit.vue?vue&type=template&id=af29f41c&"
import script from "./OcorrenciaEdit.vue?vue&type=script&lang=js&"
export * from "./OcorrenciaEdit.vue?vue&type=script&lang=js&"
import style0 from "./OcorrenciaEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports